import React, { useContext } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { Login } from "./pages/Login";
import { NotFoundPage } from "./pages/NotFoundPage";
import { UserLayout } from "./Layout/UserLayout";
import { AuthContext } from "./context/AuthContext";

const AppRouter = () => {
  const { auth } = useContext(AuthContext);

  return (
    <Routes>
      <Route
        path="/"
        element={!auth.authenticated ? <Login /> : <Navigate to="/app" />}
      />
      <Route
        path="app/*"
        element={auth.authenticated ? <UserLayout /> : <Navigate to="/" />}
      />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRouter;
